import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, ToggleButton } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';



const Play_in_automatico = (props) => {

    const [checked, setChecked] = useState(false);
    const [radioValue, setRadioValue] = useState('1');

    const radios = [
        { name: 'Manuale', value: '1' },
        { name: 'Auto', value: '2' },
    ];


    const play_in_automatico = (e) => {
        setRadioValue(e.currentTarget.value)
        if (e.currentTarget.value == '2') {
            console.log('1')
            props.funzione_play_spunta_ripetuto(true)
        }
        if (e.currentTarget.value == '1') {
            console.log('2')
            props.funzione_play_spunta_ripetuto(false)
        }
    }



    return (
        <div>
            <br />
            <ButtonGroup toggle>
                {radios.map((radio, idx) => (
                    <ToggleButton
                        key={idx}
                        type="radio"
                        variant="secondary"
                        name="radio"
                        value={radio.value}
                        checked={radioValue === radio.value}
                        onChange={play_in_automatico}   >
                        {radio.name}
                    </ToggleButton>
                ))}
            </ButtonGroup>
        </div>
    )
}
export default Play_in_automatico;




